import {
  asistenteCargaMasiva, columnasRevision, conteoPor, escapar, filaResumen, menuArchivos, menuOpciones,
  nota, notas, rangoFechas,
} from "./dialogos_carga_masiva";
import { dialogo } from "./dialogos_cartera";
import {
  CAMPOS_VEHICULO, descargarPlantillaNovedades, leerArchivoNovedades, cambiosNovedadCargada,
} from "../../functions/importar_novedades";
import { guardarCambiosMasivos } from "../../functions/importar_masivo";
import { opcionEliminar } from "./listado_comun";

// Ventanas de novedades: menú de archivos, menú de opciones de cada fila y carga desde Excel.

export const menuArchivosNovedades = ({ puedeCargar }) => menuArchivos({
  titulo: "Archivos de novedades",
  plural: "novedades",
  detalleExportar: "Descarga en Excel (CSV) las novedades que se ven en la tabla.",
  detallePlantilla: "Archivo de Excel con ejemplos para llenar las novedades.",
  detalleCargar: "Registra muchas novedades de una vez desde la plantilla llena.",
  puedeCargar,
});

// cantidadFotos ajusta el texto de la tarjeta de fotos.
export const menuAccionesNovedad = ({ novedad, cantidadFotos }) => menuOpciones({
  icono: "bi-journal-text",
  titulo: "Acciones de la novedad",
  texto: `<strong>${escapar(novedad.tipoZona || "Novedad")}</strong>${novedad.direccion ? ` · ${escapar(novedad.direccion)}` : ""}<br>${escapar(novedad.fechayhora || "")}`,
  opciones: [
    { clave: "resumen", icono: "bi-card-text", nombre: "Ver resumen",
      detalle: "Toda la novedad en una sola ventana: datos, descripción, vehículo y fotos." },
    { clave: "fotos", icono: "bi-image", nombre: "Ver fotos",
      detalle: cantidadFotos
        ? `${cantidadFotos} ${cantidadFotos === 1 ? "foto" : "fotos"} de la novedad.`
        : "Esta novedad no tiene fotos." },
    opcionEliminar("esta novedad"),
  ],
});

const seccion = (titulo, html) => `<p class="cartera-subtitulo">${titulo}</p>${html}`;

// Toda la novedad en una ventana: datos y descripción a la izquierda; vehículo y fotos a la derecha.
// novedad.fechayhora ya viene formateada para el listado y novedad.fotos es la lista de enlaces.
export const resumenNovedad = (novedad) => {
  const datos = [
    ["bi-calendar-event", "Fecha", novedad.fechayhora],
    ["bi-building", "Cliente", novedad.razonSocial],
    ["bi-person", "Reportó", novedad.usuario],
    ["bi-tag", "Tipo", novedad.tipoZona],
    ["bi-house-door", "Dirección", novedad.direccion],
    ["bi-car-front", "Placa", novedad.placa],
  ].filter(([, , valor]) => valor).map(([icono, etiqueta, valor]) => filaResumen(icono, etiqueta, escapar(valor))).join("");

  const partes = CAMPOS_VEHICULO.filter(c => novedad[c.key]);
  const malas = partes.filter(c => novedad[c.key] === "MALO").length;
  const vehiculo = partes.length ? seccion(
    `Estado del vehículo · ${malas ? `${malas} en mal estado` : "todo bueno"}`,
    `<div class="cartera-partes">${partes.map(c => {
      const malo = novedad[c.key] === "MALO";
      return `<span class="cartera-parte${malo ? " cartera-parte-mala" : ""}">
        <i class="bi ${malo ? "bi-x-circle-fill" : "bi-check-circle-fill"}"></i>${c.label}<strong>${malo ? "MALO" : "BUENO"}</strong>
      </span>`;
    }).join("")}</div>`) : "";

  const fotos = novedad.fotos.length ? seccion(`Fotos · ${novedad.fotos.length}`,
    `<div class="cartera-miniaturas">${novedad.fotos.map((url, i) =>
      `<a href="${escapar(url)}" target="_blank" rel="noopener noreferrer" title="Abrir foto ${i + 1}"><img src="${escapar(url)}" alt="Foto ${i + 1}"></a>`).join("")}</div>`) : "";

  const derecha = vehiculo + fotos;
  return dialogo({
    amplio: true,
    cerrar: true,
    icono: "bi-journal-text",
    titulo: escapar(novedad.tipoZona || "Novedad"),
    texto: escapar(novedad.fechayhora || ""),
    contenido: `<div class="cartera-columnas"${derecha ? "" : ' style="grid-template-columns:1fr"'}>
      <div>
        ${seccion("Datos", `<div class="cartera-lista">${datos}</div>`)}
        <div style="margin-top:14px">${seccion("Descripción",
          `<p class="cartera-descripcion">${escapar(novedad.descripcion_novedad || "Sin descripción")}</p>`)}</div>
      </div>
      ${derecha ? `<div class="cartera-resumen-derecha">${derecha}</div>` : ""}
    </div>`,
    confirmar: "Cerrar",
  });
};

// Devuelve true si se guardaron novedades.
export const asistenteCargarNovedades = () => asistenteCargaMasiva({
  t: {
    icono: "bi-journal-text",
    titulo: "Cargar novedades desde Excel",
    texto: "Registre muchas novedades de una sola vez con un archivo de Excel (.xlsx) o CSV.",
    notaColumnas: "Tiene las mismas columnas que la tabla. Son obligatorias <strong>TIPO DE NOVEDAD</strong> y <strong>DESCRIPCIÓN</strong>; las demás se pueden dejar vacías.",
    faltanColumnas: "<strong>TIPO DE NOVEDAD</strong> y <strong>DESCRIPCIÓN</strong>",
    filaVacia: "Escriba debajo una novedad por fila.",
    uno: "novedad",
    varios: "novedades",
    ninguno: "ninguna novedad",
    exito: "Novedades cargadas",
  },
  descargarPlantilla: descargarPlantillaNovedades,
  leer: (archivo) => leerArchivoNovedades(archivo),
  guardar: (registros) => guardarCambiosMasivos(registros, cambiosNovedadCargada),
  revision: (nombreArchivo, { registros, ejemplos }) => columnasRevision([
    filaResumen("bi-file-earmark-spreadsheet", "Archivo", escapar(nombreArchivo)),
    filaResumen("bi-journal-text", "Novedades", registros.length),
    filaResumen("bi-tag", "Tipos", conteoPor(registros, "tipo")),
    filaResumen("bi-calendar-date", "Fecha", rangoFechas(registros.map(r => r.fecha))),
    filaResumen("bi-car-front", "Con revisión de vehículo", registros.filter(r => Object.keys(r.vehiculo).length).length),
  ], ejemplos) + notas(
    nota("info", "bi-info-circle",
      "Las novedades se verán en la app y en la web igual que las creadas a mano. Las fotos se pueden ver después con el botón Opciones."),
  ),
});
